import PreviewBadge from './PreviewBadge';

const cardClasses =
    'relative overflow-hidden rounded-2xl p-7 text-white shadow-brand-card bg-primary';

const headerRowClasses = 'flex flex-wrap items-start justify-between gap-4';

const headerLeftClasses = 'flex items-center gap-4 min-w-0';

const iconWrapClasses =
    'flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/15 text-lg';

const titleClasses = 'font-serif text-card-title m-0 text-white!';

const subtitleClasses = 'text-sm text-white/70 mt-0.5 mb-0';

const messageClasses = 'text-sm text-white/85 mt-4 mb-0 max-w-2xl leading-relaxed';

const statusDotClasses = 'inline-block h-1.5 w-1.5 rounded-full bg-accent animate-pulse';

const downloadButtonClasses =
    'inline-flex items-center justify-center gap-2 rounded-lg bg-white px-5 py-2.5 mt-6 ' +
    'text-sm font-semibold text-primary! cursor-pointer transition-all duration-200 ' +
    'hover:[filter:brightness(0.96)] hover:-translate-y-px hover:shadow-btn-hover ' +
    'disabled:opacity-60 disabled:cursor-not-allowed';

const IN_PROGRESS_MESSAGE =
    'Your planner is working on the preliminary life care plan and will respond within 30 days of your request.';

const FINALIZED_MESSAGE =
    'Your preliminary life care plan is ready. Download the complete plan below.';

const PreliminaryLifecareStatusCard = ({ finalized, isDownloading, onDownload }) => (
    <div className={cardClasses}>
        <div className={headerRowClasses}>
            <div className={headerLeftClasses}>
                <span className={iconWrapClasses}>
                    <i className={finalized ? 'fas fa-circle-check' : 'fas fa-spinner animate-spin'} />
                </span>
                <div className="min-w-0">
                    <h3 className={titleClasses}>Preliminary Life Care Plan</h3>
                    <p className={subtitleClasses}>
                        {finalized ? 'Your plan is ready to download' : 'Your planner is on it'}
                    </p>
                </div>
            </div>
            {finalized ? (
                <PreviewBadge tone="success">Ready</PreviewBadge>
            ) : (
                <PreviewBadge tone="onDark">
                    <span className={statusDotClasses} />
                    In progress
                </PreviewBadge>
            )}
        </div>

        <p className={messageClasses}>{finalized ? FINALIZED_MESSAGE : IN_PROGRESS_MESSAGE}</p>

        {finalized && (
            <button
                type="button"
                className={downloadButtonClasses}
                onClick={onDownload}
                disabled={isDownloading}
            >
                <i className={isDownloading ? 'fas fa-spinner animate-spin' : 'fas fa-download'} />
                {isDownloading ? 'Preparing...' : 'Download Plan'}
            </button>
        )}
    </div>
);

export default PreliminaryLifecareStatusCard;
